// utils/permissions.ts
import { PERMISSION_MODULES } from "@/constants/permissions";

const PERMISSIONS_KEY = "user_permissions";
const ROLE_KEY = "user_role";
const MODULES_KEY = "modules";


export const getUserPermissions = (): string[] => {
  try {
    const u = localStorage.getItem(PERMISSIONS_KEY);
    if (u) {
      const permissions = JSON.parse(u);
      return Array.isArray(permissions) ? permissions : [];
    }
    return [];
  } catch (e) {
    return [];
  }
};

export const getUserRole = (): string | null => {
  return localStorage.getItem(ROLE_KEY);
};

export const getSystemModules = () => {
  try {
    const m = localStorage.getItem(MODULES_KEY);
    if (m) {
      return JSON.parse(m);
    }
    
    return PERMISSION_MODULES;
  } catch (e) {
    return PERMISSION_MODULES;
  }
};

export const hasPermission = (permissionName: string): boolean => {
  const permissions = getUserPermissions();
  return permissions.includes(permissionName);
};

/**
 * @param permissionNames - any of these permissions grants access
 */
export const hasAnyPermission = (permissionNames: string[]): boolean => {
  const permissions = getUserPermissions();
  return permissionNames.some((p) => permissions.includes(p));
};

export const hasRole = (roleNames: string[]): boolean => {
  const role = getUserRole();
  return role ? roleNames.includes(role) : false;
};



/**
 * @param {Array} moduleNames - Module names to check
 *
 * @returns {Boolean} - True if user has at least one permission in any of the given modules
 */
export const hasPermissionInModules = (moduleNames: string[]): boolean => {
  const allModules = getSystemModules();
  const userPermissions = getUserPermissions();
  return allModules.some((module: { name: any; permissions: any[] }) => {
    if (!moduleNames.includes(module.name)) return false;

    return module.permissions.some((permission) =>
      userPermissions.includes(permission)
    );
  });
};
